import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Form, Input, Button, Alert, message, Select, Space, Tag, Tooltip } from 'antd';
import Ink from 'react-ink';
import { service } from '../../../config';
import accessJson from '../../../config/access.json';

import {
  userList,
  userInsert,
  userUpdate
} from '../../../modules/user';

import { UserOutlined, UserAddOutlined, MailOutlined, LockOutlined, SolutionOutlined, ArrowRightOutlined, ToolOutlined, PlusOutlined, KeyOutlined } from '@ant-design/icons';

const { Option } = Select;
const FormItem = Form.Item;

class AddUserModal extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      message: null,
      confirmDirty: false,
      accessList: [],
      currentService: undefined,
      currentAccessRight: undefined,
      showOTPModal: false,
      otpValue: '',
      otpPendingValues: null,
    }
  }

  componentDidMount() {
    if (this.props.data && this.props.data.access) {
      this.setState({ accessList: this.props.data.access });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      if (!this.props.data) {
        this.setState({ accessList: [] });
      } else {
        this.setState({ accessList: this.props.data.access });
      }
    }

    if (this.props.show && !prevProps.show) {
      if (this.props.data && this.props.data.access) {
        this.setState({ accessList: this.props.data.access });
      } else {
        this.setState({ accessList: [] });
      }
    }
  }

  // Generate a random password
  generateRandomPassword = () => {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let password = "";

    // Ensure at least one character from each category
    password += "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(Math.random() * 26)];
    password += "abcdefghijklmnopqrstuvwxyz"[Math.floor(Math.random() * 26)];
    password += "0123456789"[Math.floor(Math.random() * 10)];
    password += "!@#$%^&*()_+"[Math.floor(Math.random() * 12)];

    // Fill the rest randomly
    for (let i = 4; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    // Shuffle the password
    password = password.split('').sort(() => 0.5 - Math.random()).join('');

    return password;
  }

  handleOTPChange = (value) => {
    this.setState({ otpValue: value });
  }

  handleOTPSubmit = () => {
    const { otpPendingValues, otpValue } = this.state;

    if (!otpValue || otpValue.length !== 6) {
      message.error('Please enter a valid 6-digit OTP');
      return;
    }

    this.setState({ loading: true });

    // add OTP to previous values
    const finalValues = {
      ...otpPendingValues,
      OTP: otpValue
    };

    this.props.userUpdate(finalValues, this.props.data.id).then(
      (res) => {
        message.success('User successfully updated!');
        if (this.formRef.current) { this.formRef.current.resetFields(); }
        this.setState({
          loading: false,
          message: null,
          accessList: [],
          showOTPModal: false,
          otpValue: '',
          otpPendingValues: null
        }, () => {
          this.onClose();
        });
      },
      (err) => {
        if (err.response?.data?.message) {
          this.setState({
            loading: false,
            message: err.response.data.message,
            showOTPModal: false
          });
        } else {
          this.setState({
            loading: false,
            message: `Can't get through. Please contact the administrator.`,
            showOTPModal: false
          });
        }
      }
    );
  }

  closeOTPModal = () => {
    this.setState({
      showOTPModal: false,
      otpValue: '',
      otpPendingValues: null,
      loading: false
    });
  }

  handleSubmit = (values) => {
    this.setState({ loading: true });
    const finalValues = {
      ...values,
      access: this.state.accessList
    };
    if (!this.props.data) {
      finalValues.password = this.generateRandomPassword(); // random a password for new user
      this.props.userInsert(finalValues).then(
        (res) => {
          message.success('User successfully added! Please inform the new user to reset password.');
          if (this.formRef.current) { this.formRef.current.resetFields(); }
          this.setState({ loading: false, message: null, accessList: [] }, () => {
            this.onClose();
          });
        },
        (err) => {
          if (err.response?.data?.message) {
            this.setState({ loading: false, message: err.response.data.message });
          } else {
            this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` });
          }
        }
      );
    } else {
      if (values.password?.length > 0 || values.originalPassword?.length > 0 || values.confirmpassword?.length > 0) {
        if (!(values.password?.length > 0 && values.originalPassword?.length > 0 && values.confirmpassword?.length > 0)) {
          this.setState({ loading: false, message: `Can't get through. Please make sure all 3 password field are filled in or contact the administrator.` });
          return;
        }
      }
      this.props.userUpdate(finalValues, this.props.data.id).then(
        (res) => {
          message.success('User successfully updated!');
          if (this.formRef.current) { this.formRef.current.resetFields(); }
          this.setState({ loading: false, message: null, accessList: [] }, () => {
            this.onClose();
          });
        },
        (err) => {
          if (err.response?.data?.message) {
            if (err?.response?.data?.message === "OTP is required") {
              this.setState({
                loading: false,
                showOTPModal: true,
                otpPendingValues: finalValues
              });
            } else {
              this.setState({ loading: false, message: err.response.data.message });
            }
          } else {
            this.setState({ loading: false, message: `Can't get through. Please make sure email is unique or contact the administrator.` });
          }
        }
      );
    }
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  handleFormValuesChange = (changedValues) => {
    if ('password' in changedValues || 'confirmpassword' in changedValues) {
      const form = this.formRef.current;
      const password = form.getFieldValue('password');
      const confirmPassword = form.getFieldValue('confirmpassword');

      if (password && confirmPassword && password === confirmPassword) {
        form.setFields([
          {
            name: 'confirmpassword',
            errors: []
          }
        ]);
      }
    }
  }

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.formRef.current;

    if (value && value.length !== 0 && value.length < 6) {
      callback('Must be at least 6 characters long');
    }
    else if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.formRef.current;

    if (value && value.length !== 0 && value.length < 6) {
      callback('Must be at least 6 characters long');
    }
    else if (value && this.state.confirmDirty) {
      form.validateFields(['confirmpassword'], { force: true });
    }
    callback();
  }

  onClose() {
    const { selectedOrganization } = this.props;
    this.setState({
      message: null,
      accessList: []
    });
    if (this.formRef.current) { this.formRef.current.resetFields(); }
    this.props.onClose && this.props.onClose();
    this.props.toggleAddUserModal();
  }

  handleServiceChange = (value) => {
    const currentValues = this.formRef.current.getFieldsValue();

    this.setState({ currentService: value }, () => {
      this.formRef.current.setFieldsValue(currentValues);
    });
  }

  handleAccessRightChange = (value) => {
    const currentValues = this.formRef.current.getFieldsValue();

    this.setState({ currentAccessRight: value }, () => {
      this.formRef.current.setFieldsValue(currentValues);
    });
  }

  addAccess = () => {
    const { currentService, currentAccessRight, accessList } = this.state;

    const currentValues = this.formRef.current.getFieldsValue();

    if (!currentService || !currentAccessRight) {
      message.error('Please select both service and access right');
      return;
    }

    // Check if service already exists
    const existingIndex = accessList.findIndex(
      item => item.split(':')[0] === currentService
    );

    if (existingIndex !== -1) {
      // Replace existing access
      const newAccessList = [...accessList];
      newAccessList[existingIndex] = `${currentService}:${currentAccessRight}`;
      this.setState({
        accessList: newAccessList,
        currentService: undefined,
        currentAccessRight: undefined
      }, () => {
        this.formRef.current.setFieldsValue(currentValues);
      });
      message.success(`Updated access for ${currentService}`);
    } else {
      // Add new access
      this.setState({
        accessList: [...accessList, `${currentService}:${currentAccessRight}`],
        currentService: undefined,
        currentAccessRight: undefined
      }, () => {
        this.formRef.current.setFieldsValue(currentValues);
      });
      message.success(`Added access for ${currentService}`);
    }
  }

  removeAccess = (access) => {
    const currentValues = this.formRef.current.getFieldsValue();

    const newAccessList = this.state.accessList.filter(item => item !== access);
    this.setState({ accessList: newAccessList }, () => {
      this.formRef.current.setFieldsValue(currentValues);
    });
  }

  render() {
    const { loading, message, accessList, currentService, currentAccessRight, showOTPModal, otpValue } = this.state;
    const { userProfile, organizations, selectedOrganization } = this.props;
    let userRole = userProfile.user.role;
    let userId = userProfile.user.id;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };

    // Available services
    const services = service;

    // Available access rights
    const accessRights = [
      'viewer',
      'editor'
    ];

    const initialValues = {
      name: (this.props.data && this.props.data.name) ? this.props.data.name : "",
      email: (this.props.data && this.props.data.email) ? this.props.data.email : "",
      password: "",
      confirmpassword: "",
      organization: (this.props.data && this.props.data.organization) ? this.props.data.organization : selectedOrganization,
      role: (this.props.data && this.props.data.role) ? this.props.data.role : undefined,
      status: (this.props.data && this.props.data.status) ? this.props.data.status : "active",
    };

    if (this.formRef.current && !loading) {
      this.formRef.current.setFieldsValue(initialValues);
    }

    return (
      <>
        <Modal
          title={(this.props.data) ? <span><UserOutlined /> User Details</span> : <span><UserAddOutlined /> Add User</span>}
          open={this.props.show}
          onCancel={() => this.onClose()}
          footer={[
            <Button key="submit" form="myUserForm" type="primary" htmlType="submit" disabled={loading} ><Ink /><ArrowRightOutlined /> Submit</Button>,
            <Button key="back" onClick={() => this.onClose()} disabled={loading}>Cancel</Button>
          ]}
          maskClosable={false}
          closable={!loading}
          width={700}
        >
          <Form className="userForm" ref={this.formRef} name="myUserForm" onFinish={this.handleSubmit} initialValues={initialValues} onValuesChange={this.handleFormValuesChange}>
            {message && <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon />}
            <FormItem  {...formItemLayout} label="Contact Name" name="name" rules={[{ required: true, message: 'Please input contact name' }]}>
              <Input disabled={(this.props.data && userId !== this.props.data.id)} prefix={<UserOutlined />} placeholder="Contact Name" />
            </FormItem>
            <FormItem  {...formItemLayout} label="Email" name="email" rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              { required: true, message: 'Please input your email!' }
            ]}>
              <Input disabled={this.props.data} autoComplete="new-password" prefix={<MailOutlined />} placeholder="Email" />
            </FormItem>

            {
              (this.props.data && userId === this.props.data.id) &&
              <FormItem  {...formItemLayout} label="Current Password" name="originalPassword">
                <Input.Password prefix={<LockOutlined />} placeholder="Current Password" />
              </FormItem>
            }

            {
              (userId === this.props.data?.id) &&
              <FormItem  {...formItemLayout}
                label={
                  <span>
                    New Password
                    {!this.props.data && (
                      <Tooltip title="Generate random secure password">
                        <Button
                          type="link"
                          icon={<KeyOutlined />}
                          onClick={this.generateRandomPassword}
                          style={{ marginLeft: 8, padding: 0 }}
                        >
                          Random
                        </Button>
                      </Tooltip>
                    )}
                  </span>
                }
                name="password"
                rules={[
                  { required: (!this.props.data), message: 'Please input your Password!' },
                  { validator: this.validateToNextPassword }
                ]}
              >
                <Input.Password autoComplete="new-password" prefix={<LockOutlined />} placeholder="New Password" />
              </FormItem>
            }

            {
              (userId === this.props.data?.id) &&
              <FormItem  {...formItemLayout} label="Confirm New Password" name="confirmpassword" rules={[
                { required: (!this.props.data), message: 'Please confirm your password!' },
                { validator: this.compareToFirstPassword }
              ]}>
                <Input.Password prefix={<LockOutlined />} placeholder="Confirm New Password" />
              </FormItem>
            }

            <FormItem  {...formItemLayout} label="Organization" name="organization" rules={[{ required: true }]}>
              <Select
                placeholder="Select a organization"
                disabled={true}
              >
                {(userRole.includes('admin')) &&
                  organizations.map((sort_items) => {
                    return <Option key={sort_items._id}
                      value={sort_items.code}>
                      {sort_items.name}
                    </Option>;
                  })
                }
              </Select>
            </FormItem>
            <FormItem  {...formItemLayout} label="Role" name="role" rules={[{ required: true, message: 'Please input organization' }]}>
              <Select
                placeholder="Select a role"
                disabled={!(userRole.includes('admin'))}
              >
                <Option value="user"><UserOutlined /> User</Option>
                {userRole.includes('admin') &&
                  <Option value="admin"><ToolOutlined /> Admin</Option>
                }
              </Select>
            </FormItem>
            <FormItem  {...formItemLayout} label="Status" name="status" rules={[{ required: true }]}>
              <Select
                disabled={!(userRole.includes('admin'))}
              >
                <Option value="active">Active</Option>
                <Option value="inactive">Inactive</Option>
              </Select>
            </FormItem>

            <FormItem {...formItemLayout} label="Access Rights">
              <div style={{ marginBottom: 16 }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                  {
                    userRole.includes('admin') &&
                    <Space>
                      <Select
                        placeholder="Select service"
                        style={{ width: 200 }}
                        value={currentService}
                        onChange={this.handleServiceChange}
                      >
                        {services.map(service => (
                          <Option key={service} value={service}>{service}</Option>
                        ))}
                      </Select>
                      <Select
                        placeholder="Select access right"
                        style={{ width: 120 }}
                        value={currentAccessRight}
                        onChange={this.handleAccessRightChange}
                      >
                        {
                          accessJson?.find(a => a.service === currentService) ?
                            accessJson.find(a => a.service === currentService).right.map(right => (
                              <Option key={right} value={right}>{right}</Option>
                            ))
                            : accessRights.map(right => (
                              <Option key={right} value={right}>{right}</Option>
                            ))
                        }
                      </Select>
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={this.addAccess}
                      >
                        Add
                      </Button>
                    </Space>
                  }

                  <div style={{ marginTop: 8 }}>
                    {accessList.map(access => {
                      const [service, right] = access.split(':');
                      let color = right === 'editor' ? 'blue' : 'green';
                      return (
                        <Tag
                          color={color}
                          key={access}
                          closable={userRole.includes('admin')}
                          onClose={() => this.removeAccess(access)}
                          style={{ marginBottom: 8 }}
                        >
                          {service}: {right}
                        </Tag>
                      );
                    })}
                  </div>
                </Space>
              </div>
            </FormItem>
          </Form>
        </Modal>

        {/* OTP Modal */}
        <Modal
          title="Two-Factor Authentication Required"
          open={showOTPModal}
          onCancel={this.closeOTPModal}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={this.handleOTPSubmit}
              loading={loading}
              disabled={!otpValue || otpValue.length !== 6}
            >
              <Ink /><ArrowRightOutlined /> Verify
            </Button>,
            <Button key="back" onClick={this.closeOTPModal} disabled={loading}>
              Cancel
            </Button>
          ]}
          maskClosable={false}
          closable={!loading}
        >
          <p>Please enter the verification code sent to your email:</p>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <Input.OTP
              length={6}
              onChange={this.handleOTPChange}
              value={otpValue}
              autoFocus
              size="large"
              style={{ width: '100%' }}
            />
          </div>
          <p style={{ textAlign: 'center', color: '#999' }}>
            The code is required to confirm your identity for this sensitive operation.
          </p>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
  organizations: state.organization.organizations,
  userProfile: state.user.userProfile,
  selectedOrganization: state.user.selectedOrganization,
  userProfile: state.user.userProfile,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      userList,
      userInsert,
      userUpdate
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddUserModal);
